(() => {
  if (window.__sunBumNormalBuyNowInstalled) return;
  window.__sunBumNormalBuyNowInstalled = true;

  const routeRoot = () => (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-sunbum-buy-now]');
    if (!button || button.disabled) return;

    const form = button.closest('form[action*="/cart/add"]');
    if (!form) return;

    event.preventDefault();
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');

    try {
      const response = await fetch(`${routeRoot()}cart/add.js`, {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: new FormData(form),
      });
      if (!response.ok) throw new Error(`Cart add failed: ${response.status}`);
      window.location.assign(`${routeRoot()}checkout`);
    } catch (error) {
      button.disabled = false;
      button.removeAttribute('aria-busy');
      const status = form.closest('product-form-component')?.querySelector('[role="status"]');
      if (status) status.textContent = 'Unable to continue to checkout. Please try again.';
    }
  });
})();
